import React from 'react';
import * as rewardsTransactionsHistoryStyle from './rewardsTransactionsHistoryStyles';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { formatCashbackCurrency } from '../CurrencyFormatting';

export const todaysDate = `${new Date().getUTCFullYear()}/${new Date().getUTCMonth() + 1}`;

export const selectRewardsTransactionsHistory = (state: IReduxRootState) =>
    state.rewardsTransactionsHistory;

/**
    e.g.
    month: toTwoDigits('4'), returns 04
    month: toTwoDigits('8'), returns 08
    month: toTwoDigits('10'), returns 10
*/
export function toTwoDigits(text: string) {
    return ('0' + text).slice(-2);
}

export const buildDatePeriodList = () => {
    const datePeriodList: string[] = [];
    const currentDate = new Date();

    let year = currentDate.getUTCFullYear();
    let month = currentDate.getUTCMonth() + 1;

    while (datePeriodList.length < 12) {
        if (month === 0) {
            year--;
            month = 12;
        } else {
            datePeriodList.push(`${year}-${toTwoDigits(month.toString())}`);
            month--;
        }
    }

    return datePeriodList;
};

export const showPointsEarntSpentSummary = (pointsEarned: number, pointsSpent: number) => {
    return (
        <span>
            <rewardsTransactionsHistoryStyle.EarnedText>
                {pointsEarned} {TranslationHelpers.getFormattedMessage('points.earned')}
            </rewardsTransactionsHistoryStyle.EarnedText>
            <rewardsTransactionsHistoryStyle.SpentText>
                {pointsSpent} {TranslationHelpers.getFormattedMessage('points.spent')}
            </rewardsTransactionsHistoryStyle.SpentText>
        </span>
    );
};
export const showCashEarntSpentSummary = (
    cashEarned: number,
    cashSpent: number,
    locale: string,
) => {
    return (
        <span>
            <rewardsTransactionsHistoryStyle.EarnedText>
                {formatCashbackCurrency(cashEarned, locale)}{' '}
                {TranslationHelpers.getFormattedMessage('points.earned')}
            </rewardsTransactionsHistoryStyle.EarnedText>
            <rewardsTransactionsHistoryStyle.SpentText>
                {formatCashbackCurrency(cashSpent, locale)}{' '}
                {TranslationHelpers.getFormattedMessage('points.spent')}
            </rewardsTransactionsHistoryStyle.SpentText>
        </span>
    );
};
